module.exports = __webpack_public_path__ + "img/perso.47151738.png";